// extracted by mini-css-extract-plugin
export default {"container":"titleSection_container__ddP1t","title":"titleSection_title__O4tcH","subTitle":"titleSection_subTitle__jn+sr","span":"titleSection_span__JUZaj"};